<template>
    <div>
      <div style="margin: 10px 0">
        <el-input style="width: 200px;" type="text" v-model="name" placeholder="请输入名称" suffix-icon="el-icon-search"></el-input>
        <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>
        
        <!-- <el-button style="float:right; " type="primary" @click="exp">导出<i class="el-icon-top"></i></el-button>
        <el-upload
          action="http://localhost:9090/user/import" :on-success = 'handelsuccess' style="float:right;margin-left: 10px">
          <el-button style="float:right;" type="primary">导入<i class="el-icon-bottom"></i></el-button>
        </el-upload> -->
        <el-button style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
        <el-button style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button>
        <el-select v-model="comid" placeholder="请选择要查看的公司" v-if = "role === '超级管理员'" style="float:right">
          <el-option v-for="item in options" 
          :key="item.id"
          :label="item.name"
          :value="item.id"></el-option>
        </el-select>
      </div>
      <!-- eslint-disable-next-line -->
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100">
        </el-table-column>
        <el-table-column prop="name" label="池塘名称" width="140">
        </el-table-column>
        <el-table-column prop="area" label="面积">
        </el-table-column>
        <el-table-column prop="fishVar" label="养殖种类">
        </el-table-column>
        <el-table-column prop="companyid" label="所属公司id" >
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <!-- scope 拿到数据-->
            <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button>
            <el-button type="danger" style="margin-right: 5px">删除</el-button>
            
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="池塘信息" :visible.sync="dialogFormVisible" width="30%" >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="池塘名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="面积( ㎡ )">
            <el-input v-model="form.area"></el-input>
          </el-form-item>
          <el-form-item label="养殖种类">
            <el-input v-model="form.fishVar"></el-input>
          </el-form-item>
          <el-form-item label="所属公司id" v-if="role==='超级管理员'">
            <el-select v-model="form.companyid" placeholder="请选择要查看的公司">
              <el-option v-for="item in options" 
              :key="item.id"
              :label="item.name"
              :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click ='shutDown'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </template>
    
    <script>
    export default {
      name: "User",
      data () {
        return{
          tableData: [],
          name: '',
          pageNum: 1,
          pageSize: 10,
          total: 0,
          dialogFormVisible: false,
          form: {},
          multipleSelection: {},
          headerBg: 'headerBg',
          data: {},
          options:[],
          user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
          comid: null,
          role : (localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{}).role,
        }
      },
      created () {
        //请求分页查询
        this.load(),
        this.getcompanies()
      },
      methods: {
        load () {//点击页码进行get请求
          this.request.get('/api/ponds/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              name: this.name,
              comid: this.user.companyid,
            }
          }).then(res => {
            this.tableData = res.records
            this.total = res.total
          }).catch(error => {
            console.error(error)
          })
        },
        getcompanies () {
          this.request.get('/api/companies/').then(res => {
            if(res.code === "200"){
              this.options = res.data.map(item => {
                return {
                  id: item.id,
                  name: item.name
                }
              })
            }else{
              console.log(res.code, res.data);
            }
          })
        },
        save () { // 新增或更新
            let user = localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{};
            this.companyid = user.companyid;
            let role = user.role;
            if(role != "超级管理员") { 
                this.request.post('/api/ponds/', this.form, {
                    params:{
                        comid:this.companyid
                    }
                }).then(res => {
                if (res) {
                this.$message.success('保存成功')
                this.dialogFormVisible = false
                this.load()
                } else {
                this.$message.success('保存失败')
                }
                })
            }else{
                let companyIdAsInt;  
                const companyIdStr = this.form.companyid;  
                if (companyIdStr && /^\d+$/.test(companyIdStr)) { // 使用正则表达式检查是否为整数  
                companyIdAsInt = parseInt(companyIdStr, 10); // 转换为整数 
                } else{
                    alert('请输入有效的公司ID（整数）！');
                }   
                this.request.post('/api/ponds/',this.form, {
                    params:{
                        comid: companyIdAsInt
                    }
                }).then(res => {
                if (res) {
                this.$message.success('保存成功')
                this.dialogFormVisible = false
                this.load()
                } else {
                this.$message.success('保存失败')
                }
                })
            }      
        },
        seleteLoad() {
          this.request.get('/api/ponds/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              comid: this.comid,
            }
          }).then(res => {
            this.tableData = res.records
            this.total = res.total
          }).catch(error => {
            console.error(error)
          })
        },
        handAdd () {
          this.dialogFormVisible = true //打开表单
          this.form = {}
        },
        handEdit (row) { //把row里的数据传给表单
          this.form = row
          this.dialogFormVisible = true
        },
        handdele (id) { //通过id删除
          this.request.delete('/api/user/' + id).then(res => {
            if (res) {
              this.$message.success('删除成功')
              this.load()
            } else {
              this.$message.success('删除失败')
            }
          })
        },
        handleSelectionChange (val) {
          console.log(val)
          this.multipleSelection = val
        },
        deleteBatch () {
          // eslint-disable-next-line
          let ids = this.multipleSelection.map(val => val.id)
          this.request.delete('/api/user/del/batch' + ids).then(res => {
            if (res) {
              this.$message.success('批量删除成功')
              this.load()
            } else {
              this.$message.success('删除失败')
            }
          })
        },
        shutDown () {
          this.dialogFormVisible = false
        },
        exp () { //导出
          window.open("http://localhost9090/user/export")
        },
        handelsuccess () {
          this.$message.success('文件上传成功')
          this.load()
        },
        handleSizeChange (pageSize) {
          this.pageSize = pageSize
          this.load()
        },
        handleCurrentChange (pageNum) {
          this.pageNum = pageNum
          this.load()
        }
      },
      watch: {
        comid: function (val) {
          this.seleteLoad()
        }
      }
    }
    </script>
    
    <style scoped>
    
    </style>
    